import React from "react";
import * as XLSX from "xlsx";

const ExportCsvTable = ({ headers, rows, filename = "Data.csv" }) => {
  const exportData = () => {
    if (!rows || !rows.length || !headers) return;

    const sheetData = [headers, ...rows];
    const sheet = XLSX.utils.aoa_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, sheet, "Sheet1");
    XLSX.writeFile(wb, filename, { bookType: "csv" });
  };

  return (
    <div
      className="flex items-center border py-2 px-4 rounded-lg cursor-pointer"
      onClick={exportData}
    >
      <img
        src="/Assets/cloud.png"
        alt=""
        className="object-contain w-4 h-6 mr-2"
      />
      <span className="font-[500] text-[10px] sm:text-sm">Download CSV</span>
    </div>
  );
};

export default ExportCsvTable;
